@if (typeReport()) {
  @if (riskResponse().triggers; as triggers) {
    @if (triggers.length > 0) {
      <div class="flex justify-between items-center w-full py-1 mb-3">
        <span class="text-[10px] font-bold uppercase max-w-fit w-full mr-1">AML Triggers</span>
        <span class="h-[1px] w-full bg-[#022D35]"></span>
        <app-info class="w-[14px] h-[14px] ml-1" [currentColor]="'text-[#9AABAE]'"
                  [text]="'Identifies the existing risk categories for this wallet at the time of latest investigation'"></app-info>
      </div>

      <div>
        @for (trigger of triggers; track $index) {
          <div
            class="flex justify-between items-start pb-[6px] mb-[6px] border-b border-solid border-black border-opacity-5">
            <div class="flex flex-col items-start">
              <span class="leading-[1.3] font-bold text-[#234542]">
                {{ trigger.category | titlecase }}
              </span>
              <span
                class="text-[11px] font-medium text-[#45525B] rounded-[60px] bg-[#23454233] px-1 pt-[2px] pb-[3px] mb-2">
                {{ trigger.percentage }}%
              </span>
              <span class="leading-[1.2] text-[11px] text-[#567474]">
                {{ trigger.message }}
              </span>
            </div>
            <div>
              <app-report-status [risk]="trigger.ruleTriggered.risk"></app-report-status>
            </div>
          </div>
        }
      </div>
    }
  }
}
